import type { Command, CommandContext } from "./Command";
import { findItem } from "../../inventory/Inventory";
import { defaultTransform, type Vec2 } from "../../world/geometry";
import type { Entity, EntityKind } from "../../world/Entity";
import type { EntityComponent } from "../../world/components";

interface DroppedItemMetadata {
  readonly kind?: EntityKind;
  readonly components?: readonly EntityComponent[];
}

export class DropItemCommand implements Command {
  constructor(
    private readonly instanceId: string,
    private readonly position: Vec2,
  ) {}

  execute(context: CommandContext): void {
    const item = findItem(context.world.inventory, this.instanceId);
    if (!item) throw new Error(`Cannot drop unknown inventory item "${this.instanceId}"`);

    context.world.removeFromInventory(this.instanceId, 1);
    const meta = item.metadata as DroppedItemMetadata | undefined;
    const entity: Entity = {
      id: `${item.definitionId}-${this.instanceId}`,
      kind: meta?.kind ?? "prop",
      definitionId: item.definitionId,
      transform: defaultTransform(this.position),
      components: meta?.components ?? [],
      visible: true,
    };
    context.world.addEntityToScene(entity);
    context.events.emit("item:dropped", {
      instanceId: this.instanceId,
      sceneId: context.world.getCurrentSceneId(),
      entityId: entity.id,
    });
  }
}
